'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VID = exports.VID = 'vid';
var UTK = exports.UTK = 'utk';
var ID = exports.ID = 'id';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/senderIdKeys.js
// module id = 691
// module chunks = 2 3